export default __webpack_public_path__ + "static/wamo-screens-a4f8aca7c30bc1b4c9c585dd79f45e46.jpg";